var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tray-wrapper-edit",
    style: _vm.style
  }, [_c('button', {
    staticClass: "button ugc-tray-wrapper-button ugc-tray-wrapper-edit-apply-button patternmaker-edit",
    attrs: {
      "type": "button",
      "disabled": _vm.disableButton
    },
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v("\n     \n  ")]), _c('div', {
    staticClass: "ugc-tray-wrapper-edit-container"
  }, [_c('button', {
    staticClass: "ugc-tray-wrapper-edit-container-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('span', {
    staticClass: "icon icon-edit"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.translations.ugcEdit))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }